import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { faker } from "@faker-js/faker";
  
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const labels = ['20-24', '25-29', '30-34', '36-'];

const dataValues = labels.map(() => faker.number.int({ min: 0, max: 10000 }));

// 최댓값과 그 인덱스 찾기
const maxValue = Math.max(...dataValues);
const maxIndex = dataValues.indexOf(Math.max(...dataValues));

const generateGradient = (context) => {
    const gradient = context.chart.ctx.createLinearGradient(0, 0, 0, context.chart.height);
    gradient.addColorStop(0, '#FE531F'); // 시작 색상
    gradient.addColorStop(1, '#FFEADE'); // 끝 색상
    return gradient;
};

export const data = {
    labels,
    datasets: [
        {
            label: '연령 통계(단위 : 명)',
            data: dataValues,
            backgroundColor: (context) => context.dataIndex === maxIndex ? generateGradient(context) : '#FFEADE', // 최댓값의 막대에 그라데이션 적용
        }
    ],
};

export const options = {
    responsive: true,
    plugins: {
        legend: {
            display: false // 범례 표시
        },
        tooltip: {
            callbacks: {
                label: function(context) {
                    let label = context.dataset.label || '';
                    if (label) {
                        label += ': ';
                    }
                    if (context.dataset.data !== null) {
                        let value = context.dataset.data[context.dataIndex];
                        label += value.toLocaleString() + '명'; // '명' 추가
                    }
                    return label;
                }
            }
        }
    },
};

const VerticalChart = () => {
    return <Bar options={options} data={data} />;
};

export default VerticalChart;